/**
 * Streamed by the taxonomy agent's write tools with exactly what they wrote, so
 * the page patches its caches from it instead of refetching into a blink.
 */
export const TAXONOMY_CHANGED_PART = 'taxonomy-changed';
/** The agents assets-api hosts on Relay; the browser addresses each by its id. */
export const TAXONOMY_AGENT_ID = 'taxonomy';
/** A schema's own agent, on its Knowledge Hub page; its context is the schema's id. */
export const TAXONOMY_SCHEMA_AGENT_ID = 'taxonomy-schema';
/** A schema's draft changed; its page reads it again. Transient. */
export const TAXONOMY_SCHEMA_CHANGED_PART = 'taxonomy-schema-changed';
/** A live progress line while an agent reads a file or writes many rows; transient. */
export const TAXONOMY_AGENT_PROGRESS_PART = 'taxonomy-agent-progress';
/** The schema agent made a taxonomy on the schema; the page opens it. */
export const TAXONOMY_CREATED_PART = 'taxonomy-created';
